import { render, staticRenderFns } from "./AppEchartBar.vue?vue&type=template&id=740d7b54&"
import script from "./AppEchartBar.vue?vue&type=script&lang=js&"
export * from "./AppEchartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports